import { Path } from "@common/constans";
import FeedbackDetails from "@components/feedback/FeedbackDetails";
import AgendaDetails from "@pages/agenda/AgendaDetails";
import AgendaViewer from "@pages/agenda/AgendaViewer";
import AttractionDetails from "@pages/attraction/AttractionDetails";
import AttractionViewer from "@pages/attraction/AttractionViewer";
import BoardingPass from "@pages/BoardingPass";
import { FlightSurvey } from "@pages/flightSurvey";
import FreeUpgrade from "@pages/FreeUpgrade";
import Itinerary from "@pages/Itinerary";
import ItineraryEn from "@pages/ItineraryEn";
import { Page } from "@pages/page";
import PaymentFailure from "@pages/PaymentFailure";
import PaymentSuccess from "@pages/PaymentSuccess";
import Event from "@pages/tourism/Event";
import TravelItinerary from "@pages/tourism/TravelItinerary";
import TripTrack from "@pages/TripTrack";
import Translate from "@service/Translate";
import React, { ComponentType } from "react";

const Booking = React.lazy(() => import("@pages/Booking"));
const CheckIn = React.lazy(() => import("@pages/CheckIn"));
const CityInformation = React.lazy(() => import("@pages/CityInformation"));
const ContactUs = React.lazy(() => import("@pages/ContactUs"));
const DomesticRoute = React.lazy(() => import("@pages/DomesticRoute"));
const ETicket = React.lazy(() => import("@pages/ETicket"));
const FAQ = React.lazy(() => import("@pages/FAQ"));
const FeedBack = React.lazy(() => import("@pages/FeedBack"));
const Fleet = React.lazy(() => import("@pages/Fleet"));
const FleetSeatMap = React.lazy(() => import("@pages/FleetSeatMap"));
const InternationalRoute = React.lazy(() => import("@pages/InternationalRoute"));
const KidsStory = React.lazy(() => import("@pages/KidsStory"));
const Laboratories = React.lazy(() => import("@pages/Laboratories"));
const LostBaggage = React.lazy(() => import("@pages/LostBaggage"));
const Magazine = React.lazy(() => import("@pages/Magazine"));
const ManageBooking = React.lazy(() => import("@components/manageBooking/ManageBooking"));
const Modify = React.lazy(() => import("@pages/Modify"));
const News = React.lazy(() => import("@pages/News"));
const NewsDetail = React.lazy(() => import("@pages/NewsDetail"));
const Profile = React.lazy(() => import("@components/profile/Profile"));
const ReservationStatus = React.lazy(() => import("@pages/ReservationStatus"));
const SalesOffices = React.lazy(() => import("@pages/SalesOffices"));
const Survey = React.lazy(() => import("@pages/survey/Survey"));
const TravelConditions = React.lazy(() => import("@pages/travelConditions/TravelConditions"));

export interface IRouteItem {
  children?: IRouteItem[];
  component?: ComponentType;
  exact?: boolean;
  // show/hide this item in menu list
  hidden?: boolean;
  // show icon on menu
  icon?: string;
  link: string;
  onClick?: () => void;
  // permissions?: IPermissions;
  title: string;
}

export function getRoutes(isLoggedIn: boolean): IRouteItem[] {
  const { tr } = Translate;
  const userRoutes = [{ link: "", title: "" }];
  const guestRoutes = [
    { link: Path.Home, title: tr("home"), component: Page, exact: true },
    { link: Path.Booking.ManageBooking, title: tr("pnr_info"), component: ManageBooking },
    { link: Path.Booking.Itinerary, title: tr("itinerary"), component: Itinerary },
    { link: Path.Booking.ItineraryEn, title: tr("itinerary"), component: ItineraryEn },
    { link: Path.Booking.Ticket, title: tr("ticket"), component: ETicket },
    { link: Path.Booking.ReservationStatus, title: tr("reservation_status"), component: ReservationStatus },
    { link: Path.Booking.Home, title: tr("booking"), component: Booking },
    { link: Path.Modify.Home, title: tr("btn_modify"), component: Modify },
    { link: Path.Payment.Failed, title: tr("payment_failed"), component: PaymentFailure },
    { link: Path.Payment.Successed, title: tr("payment_success"), component: PaymentSuccess },
    { link: Path.Checkin.Login, title: tr("check_in"), component: CheckIn },
    { link: Path.Checkin.BoardingPass, title: tr("boarding_pass"), component: BoardingPass },
    { link: Path.Checkin.TripTrack, title: tr("trip_track"), component: TripTrack },
    { link: Path.LostBaggage, title: tr("lost-baggage"), component: LostBaggage },
    { link: Path.Profile.Home, title: tr("profile"), component: Profile },
    { link: Path.News, title: tr("news_and_announcements"), component: News, exact: true },
    { link: `${Path.News}/:id`, title: tr("news_and_announcements"), component: NewsDetail },
    { link: Path.Magazine, title: tr("magazines"), component: Magazine },
    { link: Path.KidsStory, title: tr("kids_story"), component: KidsStory },
    { link: Path.Fleet, title: tr("fleet"), component: Fleet },
    { link: Path.FleetSeatMap, title: tr("fleet_seat_map"), component: FleetSeatMap },
    { link: Path.SalesOffices, title: tr("sales_offices"), component: SalesOffices },
    { link: Path.Laboratories, title: tr("laboratories"), component: Laboratories },
    { link: Path.DomesticRoute, title: tr("domestic_route"), component: DomesticRoute },
    { link: Path.InternationalRoute, title: tr("international_route"), component: InternationalRoute },
    { link: Path.TravelConditions, title: tr("travel_conditions"), component: TravelConditions },
    { link: Path.Survey, title: tr("survey"), component: Survey },
    { link: Path.ContactUs, title: tr("contact_us"), component: ContactUs },
    { link: `${Path.Destinations}/:id`, title: tr("city_information"), component: CityInformation },
    { link: Path.PrivacyPolicy, title: tr("city_information"), component: Page },
    { link: Path.TermCondition, title: tr("city_information"), component: Page },
    { link: Path.FreeUpgrade, title: tr("free_upgrade_winners"), component: FreeUpgrade },
    { link: Path.Feedback.Details, title: tr("profile"), component: FeedbackDetails },
    { link: Path.Feedback.FeedbackItem, title: tr("profile"), component: FeedbackDetails },
    { link: Path.Feedback.Home, title: tr("feedback"), component: FeedBack },
    { link: Path.CRM, title: tr("CRM"), component: Page },
    { link: Path.FlightSurvey.Start, title: tr("flight_survey"), component: FlightSurvey },
    { link: Path.Signout, title: tr("profile"), component: Page },
    { link: Path.FAQ, title: tr("FAQ"), component: FAQ },
    { link: Path.Tourism.Event, title: tr("FAQ"), component: Event },
    { link: `${Path.Tourism.Itinerary}/:id`, title: tr("mahan_air"), component: TravelItinerary },
    { link: Path.Tourism.Agenda, title: tr("agenda"), component: AgendaViewer, exact: true },
    { link: `${Path.Tourism.AgendaDetail}/:id`, title: tr("agenda_detail"), component: AgendaDetails },
    { link: Path.Tourism.Attraction, title: tr("attraction"), component: AttractionViewer, exact: true },
    { link: `${Path.Tourism.AttractionDetail}/:id`, title: tr("attraction_detail"), component: AttractionDetails },
  ];

  return isLoggedIn ? userRoutes : guestRoutes;
}

export const planePage = [Path.Checkin.BoardingPass, Path.Checkin.TripTrack, Path.FlightSurvey.Start, Path.FlightSurvey.Questionnaire, Path.FlightSurvey.Feedback, Path.Booking.ItineraryEn, Path.Feedback.Details, Path.Tourism.Itinerary];
export const mobileViewPage = [Path.Checkin.BoardingPass, Path.Checkin.TripTrack];
export const scrollUpExceptionURLs = [Path.Checkin.SelectSeat, Path.Profile.History];
export const scrollDisableURLs = ["/map"];
export const bookingUrls = [Path.Booking.SelectFlight, Path.Booking.PaxInfo, Path.Booking.SpecialServices, Path.Booking.PrePayment, Path.Modify.FlightSearch, Path.Modify.SelectFlight, Path.Modify.SpecialServices, Path.Modify.PrePayment];
export const transactionTimeoutUrls = [Path.Booking.SelectFlight, Path.Booking.PaxInfo, Path.Booking.SpecialServices, Path.Booking.PrePayment, Path.Booking.ManageBooking, Path.Modify.FlightSearch, Path.Modify.SelectFlight, Path.Modify.SpecialServices, Path.Modify.PrePayment, Path.Checkin.SelectPassenger, Path.Checkin.SelectSeat];
